// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"272":"621cde1b","279":"969bc49b","454":"4f6316de","467":"969bc49b","515":"969bc49b","565":"969bc49b","679":"fddab232"}[chunkId] + ".chunk.css";
};